module.exports = __webpack_public_path__ + "static/media/AP_NES_Z2.7ec8fd11.png";